import { useMemo } from 'react';
import { toDateOrNull, formatDateRange } from 'src/helpers/date-helpers';
import { FormDateInputComponent } from 'src/features/generalForms/builder/types/DateInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormDateRangeInput: FormDateInputComponent = (props) => {
  const [from, to] = useAnswerValue(props.dataKey!) ?? [];
  const isEmpty = useMemo(() => !toDateOrNull(from) && !toDateOrNull(to), [from, to]);

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return (
    <AnswerPreviewRow<(Date | undefined)[]>
      value={isEmpty ? undefined : [toDateOrNull(from) ?? undefined, toDateOrNull(to) ?? undefined]}
      renderValue={([f, t]) => formatDateRange(f, t)}
      isOptional={props.endDateIsOptional && props.startDateIsOptional}
      {...props}
    />
  );
};
